import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { Crosshair } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [token, setToken] = useState(params.get("token") || "");
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (pw !== pw2) { setErr("Passwords do not match"); return; }
    if (pw.length < 6) { setErr("Password must be at least 6 characters"); return; }
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      setDone(true);
      setTimeout(() => navigate("/login"), 1800);
    } catch (e) {
      setErr(e.response?.data?.detail || "Reset failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white flex items-center justify-center p-6">
      <div className="w-full max-w-sm" data-testid="reset-page">
        <div className="flex items-center gap-3 mb-10">
          <img src="/rd-logo.jpeg" alt="" className="w-10 h-10 rounded-md object-cover" />
          <span className="font-heading text-2xl font-black tracking-tight">RD <span className="text-[#FF3B30]">SmartMetrics</span></span>
        </div>
        <div className="overline mb-2">// set new password</div>
        <h2 className="font-heading text-4xl font-black uppercase mb-8">Reset</h2>

        {done ? (
          <div className="card-tactical p-5 text-sm text-[#34C759]" data-testid="reset-success">
            Password updated. Redirecting to sign in…
          </div>
        ) : (
          <form onSubmit={submit} data-testid="reset-form">
            {err && <div className="mb-4 px-3 py-2 border border-[#FF3B30]/40 text-[#FF3B30] text-sm" data-testid="reset-error">{err}</div>}
            <label className="block mb-5">
              <span className="overline block mb-2">Token</span>
              <input
                data-testid="reset-token"
                value={token}
                onChange={(e) => setToken(e.target.value)}
                required
                className="w-full bg-transparent border-b border-white/20 py-2 text-white focus:border-[#FF3B30] font-mono text-xs"
              />
            </label>
            <label className="block mb-5">
              <span className="overline block mb-2">New Password</span>
              <input
                data-testid="reset-password"
                type="password"
                value={pw}
                onChange={(e) => setPw(e.target.value)}
                required
                className="w-full bg-transparent border-b border-white/20 py-2 text-white focus:border-[#FF3B30]"
              />
            </label>
            <label className="block mb-8">
              <span className="overline block mb-2">Confirm Password</span>
              <input
                data-testid="reset-password-confirm"
                type="password"
                value={pw2}
                onChange={(e) => setPw2(e.target.value)}
                required
                className="w-full bg-transparent border-b border-white/20 py-2 text-white focus:border-[#FF3B30]"
              />
            </label>
            <button
              type="submit"
              disabled={busy}
              data-testid="reset-submit"
              className="w-full bg-[#FF3B30] hover:bg-[#D92B22] text-white font-bold uppercase tracking-[0.18em] py-3 text-sm disabled:opacity-50"
            >
              {busy ? "Updating…" : "Update Password"}
            </button>
          </form>
        )}

        <div className="mt-6 text-xs text-[#A1A1AA]">
          <Link to="/login" className="text-white underline">Back to sign in</Link>
        </div>
      </div>
    </div>
  );
}
